import forEach from 'utils/DOM/forEach'

function removeElements(selector: StringOrNodeSelector) {
  forEach(selector, node => {
    node.parentNode.removeChild(node)
  })
}

export default removeElements
